import { createSlice } from "@reduxjs/toolkit";
import { SupportList } from "../Actions/AdminActions";

export const supportSlice = createSlice({
    name: "supportSlice",
    initialState: {
        alldata: "",
        loading: false,
        error: null,
    },
    reducers: {
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(SupportList.pending, (state) => {
                state.loading = true; 
                state.error = null;  
            })
            .addCase(SupportList.fulfilled, (state, action) => {
                state.loading = false; 
                state.alldata = action.payload.data; 
            })
            .addCase(SupportList.rejected, (state, action) => {
                state.loading = false; 
                state.error = action.error.message; 
            });
    },
});

export default supportSlice.reducer;
